import { createSlice } from "@reduxjs/toolkit";
import {
  checkInvoiceIsraelToken,
  completeIsraelInvoiceAuthorization,
} from "../thunks/israelInvoiceThunks";
import {
  CheckInvoiceIsraelTokenResponse,
  CompleteIsraelInvoiceAuthResponse,
} from "../../models/IsraelInvoice.model";

interface IsraelInvoiceState {
  checkTokenLoading: boolean;
  checkTokenError: string | null;
  checkTokenResult: CheckInvoiceIsraelTokenResponse | null;
  completeAuthLoading: boolean;
  completeAuthError: string | null;
  completeAuthResult: CompleteIsraelInvoiceAuthResponse | null;
}

const initialState: IsraelInvoiceState = {
  checkTokenLoading: false,
  checkTokenError: null,
  checkTokenResult: null,
  completeAuthLoading: false,
  completeAuthError: null,
  completeAuthResult: null,
};

const israelInvoiceSlice = createSlice({
  name: "israelInvoice",
  initialState,
  reducers: {
    resetIsraelInvoiceState: () => initialState,
    clearIsraelInvoiceErrors: (state) => {
      state.checkTokenError = null;
      state.completeAuthError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(checkInvoiceIsraelToken.pending, (state) => {
        state.checkTokenLoading = true;
        state.checkTokenError = null;
      })
      .addCase(checkInvoiceIsraelToken.fulfilled, (state, action) => {
        state.checkTokenLoading = false;
        state.checkTokenResult = action.payload;
      })
      .addCase(checkInvoiceIsraelToken.rejected, (state, action) => {
        state.checkTokenLoading = false;
        state.checkTokenError =
          (action.payload as string) || "שגיאה בבדיקת טוקן חשבונית ישראל";
      })
      .addCase(completeIsraelInvoiceAuthorization.pending, (state) => {
        state.completeAuthLoading = true;
        state.completeAuthError = null;
      })
      .addCase(
        completeIsraelInvoiceAuthorization.fulfilled,
        (state, action) => {
          state.completeAuthLoading = false;
          state.completeAuthResult = action.payload;
        },
      )
      .addCase(completeIsraelInvoiceAuthorization.rejected, (state, action) => {
        state.completeAuthLoading = false;
        state.completeAuthError =
          (action.payload as string) || "שגיאה בהשלמת הזדהות חשבונית ישראל";
      });
  },
});

export const { resetIsraelInvoiceState, clearIsraelInvoiceErrors } =
  israelInvoiceSlice.actions;

export default israelInvoiceSlice.reducer;
